<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/yMgL2G/tc-custom/9781488060151.jpg?1701235130069" alt="This image is the cover for the book Prodigal Cowboy, Mercy Ranch"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Prodigal Cowboy, Mercy Ranch
      </h1>
      <p class="bookDescription body article font2">
        <p>Can an unexpected reunion change his wandering ways?<br/><br/><b>His last chance to make things right…</b><br/><br/><b>means reuniting the family he once lost.</b><br/><br/>Bull fighter Colt West gave up everything for the rodeo—including his sweetheart, Holly Carter. Now he’s come home to Hope, Oklahoma, with unexpected news: he and Holly are the guardians of the daughter they gave up for adoption eleven years ago. It’s a chance to be a family. But can Holly trust that her cowboy is finally here to stay?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Brenda Minton
      </h2>
      
      <p class="authorDescription body article">Brenda Minton lives in the Ozarks. She&#39;s a wife, mom to three, foster mom to five and grandma to a princess.&#160; Life is chaotic but she enjoys every minute of it with her family and a few too many dogs. When not writing she&#39;s drinking coffee on the patio, wrangling kids or escaping for an evening out &#160;with her husband.&#160; Visit her online at www.brendaminton.net</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0d6ce49f